export default __webpack_public_path__ + "static/media/wf-isf-perspective-city-of-refuge-desktop.4d2c1ec2.jpg";